import { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PageViewTracker from "../utils/analytics";
import Loader from "../components/common/Loader";
import Layout from "../components/layout/Layout";

const HomePage = lazy(() => import("../pages/Home/HomePage"));
const CategoryPage = lazy(() => import("../pages/Category/CategoryPage"));
const ProductDetailPage = lazy(() =>
  import("../pages/Product/ProductDetailPage")
);
const SearchResultsPage = lazy(() =>
  import("../pages/Search/SearchResultsPage")
);
const CartPage = lazy(() => import("../pages/Cart/CartPage"));
const CheckoutPage = lazy(() => import("../pages/Checkout/CheckoutPage"));
const OrderConfirmPage = lazy(() => import("../pages/Order/OrderConfirmPage"));
const ReorderPage = lazy(() => import("../pages/Reorder/ReorderPage"));
const NotFound = lazy(() => import("../pages/NotFound"));
const Contact = lazy(() => import("../pages/Contact/Contact"));

const Router = () => (
  <BrowserRouter>
    <PageViewTracker />
    <Suspense fallback={<Loader />}>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/category/:slug" element={<CategoryPage />} />
          <Route path="/product/:id" element={<ProductDetailPage />} />
          <Route path="/search" element={<SearchResultsPage />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/order/confirm" element={<OrderConfirmPage />} />
          <Route path="/reorder" element={<ReorderPage />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </Suspense>
  </BrowserRouter>
);

export default Router;
